import { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Alert,
  Snackbar,
} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { generateAPIkey } from "../../../../../../backendServices/ApiCalls";


export default function ApiKeySection() {
  const [open, setOpen] = useState(false);
  const [apiKey, setApiKey] = useState(null);
  const [showKey, setShowKey] = useState(false);
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleGenerate =  () => {

      setLoading(true);

    generateAPIkey( (response) => {
        setApiKey(response?.data?.apiKey);
           setLoading(false);
            setOpen(false)
      },
      (error) => {
          setLoading(false);
           setOpen(false)
      })
    
     
 
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(apiKey);
    setCopied(true);
  };

  return (
    <Box sx={{ p: 3, border: "1px solid #eee", borderRadius: 2 }}>
      <Typography sx={{fontWeight:600}} variant="h1" gutterBottom>
        API Key
      </Typography>

      {!apiKey && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpen(true)}
        >
          Generate API Key
        </Button>
      )}

      {apiKey && (
        <Box mt={2}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            This API key will only be shown once. Please copy and store it securely.
          </Alert>

          <Box display="flex" alignItems="center">
            <TextField
              fullWidth
              type={showKey ? "text" : "password"}
              value={apiKey}
              InputProps={{
                readOnly: true
              }}
            />

            <IconButton onClick={() => setShowKey(!showKey)}>
              {showKey ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </IconButton>

            <IconButton onClick={handleCopy}>
              <ContentCopyIcon />
            </IconButton>
          </Box>
        </Box>
      )}

      {/* Confirmation Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Generate New API Key?</DialogTitle>
        <DialogContent>
          Generating a new key may invalidate the previous one.
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleGenerate}
          >
            {loading ? "Generating..." : "Generate"}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={copied}
        autoHideDuration={2000}
        onClose={() => setCopied(false)}
      >
        <Alert severity="success">Copied to clipboard!</Alert>
      </Snackbar>
    </Box>
  );
}